import { handleActions } from "redux-actions";
import { COMPANY_DISCOUNTS } from "constants/action-types";
import { fetchActions, IFetchStoreState, initialFetchState, updateActions } from "./base-reducers";
import { CompanyDiscount } from "components/company-discounts/company-discounts";

export const companyDiscounts = handleActions<IFetchStoreState<CompanyDiscount[]>>(
    {
        ...fetchActions(COMPANY_DISCOUNTS.FETCH),
        ...updateActions(COMPANY_DISCOUNTS),
    } as any,
    initialFetchState,
);
